import { render, staticRenderFns } from "./Jumenterie.vue?vue&type=template&id=9e540c7e&"
import script from "./Jumenterie.vue?vue&type=script&lang=js&"
export * from "./Jumenterie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports